import { X, ChevronLeft, ChevronRight, Sparkles, Send } from 'lucide-preact'

interface AssetReviewTopBarProps {
  onClose: () => void
  onPrevious: (() => void) | null
  onNext: (() => void) | null
  currentIndex: number
  totalAssets: number
  onEditInWebster?: () => void
  /** When provided, renders a "Send test to me" action (Email Copy review only). */
  onSendTest?: () => void
  sendingTest?: boolean
  /** Disables the action without hiding it — e.g. while a selected past version's HTML loads. */
  sendTestDisabled?: boolean
}

export function AssetReviewTopBar({ onClose, onPrevious, onNext, currentIndex, totalAssets, onEditInWebster, onSendTest, sendingTest, sendTestDisabled }: AssetReviewTopBarProps) {
  return (
    <div className="flex items-center justify-between h-14 px-4 border-b border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 flex-shrink-0">
      <div className="flex items-center gap-3">
        <button
          onClick={onClose}
          className="inline-flex items-center justify-center w-8 h-8 rounded-md text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500"
          title="Close"
        >
          <X className="w-5 h-5" />
        </button>
        <h1 className="text-base font-semibold text-slate-900 dark:text-slate-100">Asset Review</h1>

        {onEditInWebster && (
          <button
            onClick={onEditInWebster}
            className="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded border border-primary-300 dark:border-primary-700 bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300 hover:bg-primary-100 dark:hover:bg-primary-900/30 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            <Sparkles className="w-3.5 h-3.5" />
            Edit in Webster
          </button>
        )}

        {onSendTest && (
          <button
            onClick={onSendTest}
            disabled={sendingTest || sendTestDisabled}
            title="Send a test of this email to your own address"
            className="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            <Send className="w-3.5 h-3.5" />
            {sendingTest ? 'Sending…' : 'Send test to me'}
          </button>
        )}

      </div>

      <div className="flex items-center gap-2">
        <span className="text-xs text-slate-500 dark:text-slate-400 mr-1">
          {currentIndex + 1} of {totalAssets}
        </span>
        <button
          onClick={onPrevious ?? undefined}
          disabled={!onPrevious}
          className="inline-flex items-center gap-1 px-2.5 py-1.5 text-xs font-medium rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500"
        >
          <ChevronLeft className="w-3.5 h-3.5" />
          Previous
        </button>
        <button
          onClick={onNext ?? undefined}
          disabled={!onNext}
          className="inline-flex items-center gap-1 px-2.5 py-1.5 text-xs font-medium rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500"
        >
          Next
          <ChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  )
}
